import type { ReactNode } from "react";

const PADDING_POR_TAMANO = {
  compacta: "p-4",
  normal: "p-5",
  grande: "p-6",
} as const;

export function Tarjeta({
  children,
  className = "",
  tamano = "normal",
  interactiva = false,
}: {
  children: ReactNode;
  className?: string;
  tamano?: keyof typeof PADDING_POR_TAMANO;
  /** Opt-in: sombra más marcada al pasar el mouse y esquinas más redondeadas — usado en el Dashboard, sin afectar el resto de la app por defecto. */
  interactiva?: boolean;
}) {
  const redondeo = interactiva ? "rounded-2xl" : "rounded-xl";
  const sombra = interactiva ? "shadow-md transition-shadow duration-200 hover:shadow-xl" : "shadow-md";
  return (
    <div className={`h-full ${redondeo} border border-borde bg-superficie ${sombra} ${PADDING_POR_TAMANO[tamano]} ${className}`}>
      {children}
    </div>
  );
}

export function TarjetaIndicador({
  etiqueta,
  valor,
  tono = "neutro",
}: {
  etiqueta: string;
  valor: string | number;
  tono?: "neutro" | "alerta" | "exito";
}) {
  const colorValor = tono === "alerta" ? "text-error" : tono === "exito" ? "text-exito" : "text-texto";
  return (
    <Tarjeta tamano="compacta">
      <p className="text-xs font-medium uppercase tracking-wide text-texto-secundario">{etiqueta}</p>
      <p className={`mt-1.5 text-2xl font-semibold ${colorValor}`}>{valor}</p>
    </Tarjeta>
  );
}
